import { useState } from 'react';
import {
  Box,
  ClickAwayListener,
  IconButton,
  Paper,
  Popper,
  Typography,
  Grid,
  Tooltip,
  useTheme,
  Divider,
  useMediaQuery,
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import PaymentsIcon from '@mui/icons-material/Payments';
import GroupsIcon from '@mui/icons-material/Groups';
import { useModal } from '../../layouts/MainLayout';
import BadgeIcon from '@mui/icons-material/Badge';
import { useNavigate } from 'react-router-dom';
import TableHeadingTypography from '../commonComponent/TableHeadingTypography';

const AddNewDropdown = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDark = theme.palette.mode === 'dark';
  const [openPopper, setOpenPopper] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setModalState } = useModal();
  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopper((prev) => !prev);
  };

  const handleClosePopper = () => {
    setOpenPopper(false);
  };


  const items = [
    {
      title: 'Add Student',
      bgColor: '#d9b3ff',
      icon: <i class="fa-sharp fa-solid fa-graduation-cap" style={{color:'#8e24aa'}}></i>,
      action : () => {
    navigate('/add-student');
    setOpenPopper(false);
  }
    },
   
    {
      title: 'Add Staff',
      bgColor: '#ffe0b2',
      icon: <i class="fa-solid fa-chalkboard-user " style={{ color: '#e65100 '}}></i>,
       action: () => {
             navigate('/add-staff');
    setOpenPopper(false);
      
      }
    },
    {
      title: 'Attendance',
      bgColor: '#bbdefb',
      
      icon:<i class="fa-sharp fa-solid fa-clipboard-user"  style={{ color: '#0d47a1 '}} ></i> ,
      action: () => {
                     navigate('/student-attendance');
    setOpenPopper(false);
      }
    },
    {
      title: 'Collect  Fee',
      bgColor: '#81c784',
      icon: <PaymentsIcon sx={{ color: theme.palette.background.classDashIcon }} />,
           action: () => {
                     navigate('/collect');
    setOpenPopper(false);
      }
    },
  ];


  return (
    <>
      <Tooltip title="Shortcut">
        <IconButton
          onClick={handleToggle}
          className="head-icon-btn"
          sx={{ color: theme.palette.background.text, borderColor: theme.palette.custom.borderColor }}
        >
          {/* <IconFileSymlink stroke={2} size={16} /> */}
          <i class="fa-sharp fa-regular fa-grid-2 fs-16"></i>
        </IconButton>
      </Tooltip>

      <Popper open={openPopper} anchorEl={anchorEl} placement="bottom-end" sx={{ zIndex: 1300 }}>
        <ClickAwayListener onClickAway={handleClosePopper}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              width: {xs:230,sm:230,md:180},
              position: 'absolute',
              top: {xs:12,sm:12,md:14},
              right: 0,
              transform:{xs:'translateX(50%)',sm:'translateX(50%)',md:'translateX(0)'},
              borderRadius: 2,
              backgroundColor: theme.palette.mode === 'dark' ? '#06080a' : theme.palette.background.paper,
              boxShadow:'0px 8px 12px rgba(0, 0, 0, 0.1)'


              // '&::before': {
              //   content: '""',
              //   display: 'block',
              //   position: 'absolute',
              //   top: 0,
              //   right: 14,
              //   width: 10,
              //   height: 10,
              //   bgcolor: 'background.paper',
              //   transform: 'translateY(-50%) rotate(45deg)',
              //   zIndex: 0,
              // },
            }}
          >

           <TableHeadingTypography
           sx={{mb:1}}
                text=" Quick Access"
                variant="h6"
              />
            <Divider sx={{ mb: 2, borderColor: (theme) => `${theme.palette.custom.borderColor}`, }} />
            <Grid container spacing={2}>
              {items.map((item, index) => (
                <Grid item size={{ xs: 6 }} key={index}>
                  <Box
                    onClick={item.action}
                    sx={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 2,
                      transition: '0.3s',
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: item.bgColor,
                        borderRadius: '50%',
                        width: 60,
                        height: 60,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontSize: '13px',
                        color: theme.palette.mode === 'dark' ? '#ccc' : '#6c6f75',
                        fontWeight: 600,
                        textAlign: 'center',
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Paper>
        </ClickAwayListener>
      </Popper>

      
    </>
  );
};

export default AddNewDropdown;